import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { separationActions as actions, notificationActions } from '../actions';
import { SeparationService } from '../services';

/* Add Separation Sagas */
function* handleApplySeparationRequest() {
    const action = yield take(actions.applySeparationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(SeparationService.applySeparation, dataParams);
        if (res.isError) {
            yield put(actions.applySeparationError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.applySeparationSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.applySeparationError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Separation Sagas */
function* handleUpdateSeparationRequest() {
    const action = yield take(actions.updateSeparationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(SeparationService.updateSeparation, dataParams);
        if (res.isError) {
            yield put(actions.updateSeparationError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.updateSeparationSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }

    } catch (error) {
        yield put(actions.updateSeparationError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Separation By Department Sagas */
function* handleGetSeparationRequest() {
    const action = yield take(actions.getSeparationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(SeparationService.getSeparation, dataParams);
        if (res.isError) {
            yield put(actions.getSeparationError(res));

        } else {
            yield put(actions.getSeparationSuccess(res));
        }

    } catch (error) {
        yield put(actions.getSeparationError());
    }
}

/* Update Separation Sagas */
function* handleGetSeparationApprovalRequest() {
    const action = yield take(actions.getSeparationApprovalRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(SeparationService.getSeparationApproval, dataParams);
        if (res.isError) {
            yield put(actions.getSeparationApprovalError(res));

        } else {
            yield put(actions.getSeparationApprovalSuccess(res));

        }
    } catch (error) {
        yield put(actions.getSeparationApprovalError());

    }
}
/* Delete Separation Sagas */
function* handleApproveRejectSeparationRequest() {
    const action = yield take(actions.approveRejectSeparationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(SeparationService.approveRejectSeparation, dataParams);
        if (res.isError) {
            yield put(actions.approveRejectSeparationError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.approveRejectSeparationSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.approveRejectSeparationError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}



/* Add Separation Sagas */
function* handleGetClearanceQuestionRequest() {
    const action = yield take(actions.getClearanceQuestionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(SeparationService.getClearanceQuestion, dataParams);
        if (res.isError) {
            yield put(actions.getClearanceQuestionError(res));

        } else {
            yield put(actions.getClearanceQuestionSuccess(res));

        }
    } catch (error) {
        yield put(actions.getClearanceQuestionError());

    }
}

/* Apply Clearance Form Sagas */
function* handleApplyClearanceFormRequest() {
    const action = yield take(actions.applyClearanceFormRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(SeparationService.applyClearanceForm, dataParams);
        if (res.isError) {
            yield put(actions.applyClearanceFormError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.applyClearanceFormSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }

    } catch (error) {
        yield put(actions.applyClearanceFormError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Show Clearance Form Sagas */
function* handleSeparationDetailsRequest() {
    const action = yield take(actions.separationDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(SeparationService.separationDetails, dataParams);
        if (res.isError) {
            yield put(actions.separationDetailsError(res));

        } else {
            yield put(actions.separationDetailsSuccess(res));
        }

    } catch (error) {
        yield put(actions.separationDetailsError());
    }
}

/* Get Clearance Sagas */
function* handleGetClearanceRequest() {
    const action = yield take(actions.getClearanceRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(SeparationService.getClearance, dataParams);
        if (res.isError) {
            yield put(actions.getClearanceError(res));

        } else {
            yield put(actions.getClearanceSuccess(res));
        }

    } catch (error) {
        yield put(actions.getClearanceError());
    }
}


/* -----------Watchers------------- */
function* handleApplySeparationWatcher() {
    yield takeEvery(
        actions.applySeparationRequest,
        handleApplySeparationRequest,
    );
}

function* handleUpdateSeparationWatcher() {
    yield takeEvery(
        actions.updateSeparationRequest,
        handleUpdateSeparationRequest,
    );
}

function* handleGetSeparationWatcher() {
    yield takeEvery(
        actions.getSeparationRequest,
        handleGetSeparationRequest,
    );
}

function* handleGetSeparationApprovalWatcher() {
    yield takeEvery(
        actions.getSeparationApprovalRequest,
        handleGetSeparationApprovalRequest,
    );
}

function* handleApproveRejectSeparationWatcher() {
    yield takeEvery(
        actions.approveRejectSeparationRequest,
        handleApproveRejectSeparationRequest,
    );
}


/* -----------Watchers------------- */
function* handleGetClearanceQuestionWatcher() {
    yield takeEvery(
        actions.getClearanceQuestionRequest,
        handleGetClearanceQuestionRequest,
    );
}

function* handleApplyClearanceFormWatcher() {
    yield takeEvery(
        actions.applyClearanceFormRequest,
        handleApplyClearanceFormRequest,
    );
}

function* handleSeparationDetailsWatcher() {
    yield takeEvery(
        actions.separationDetailsRequest,
        handleSeparationDetailsRequest,
    );
}

function* handleGetClearanceWatcher() {
    yield takeEvery(
        actions.getClearanceRequest,
        handleGetClearanceRequest,
    );
}


function* rootSeparationSaga() {
    yield all([
        handleApplySeparationRequest(),
        handleApplySeparationWatcher(),

        handleUpdateSeparationRequest(),
        handleUpdateSeparationWatcher(),

        handleGetSeparationRequest(),
        handleGetSeparationWatcher(),

        handleGetSeparationApprovalRequest(),
        handleGetSeparationApprovalWatcher(),

        handleApproveRejectSeparationRequest(),
        handleApproveRejectSeparationWatcher(),

        handleGetClearanceQuestionRequest(),
        handleGetClearanceQuestionWatcher(),

        handleApplyClearanceFormRequest(),
        handleApplyClearanceFormWatcher(),

        handleSeparationDetailsRequest(),
        handleSeparationDetailsWatcher(),

        handleGetClearanceRequest(),
        handleGetClearanceWatcher(),
    ]);
}

export default rootSeparationSaga;
